export default "__VITE_ASSET__vM8PgL39__"